export const isBrowser = typeof window !== "undefined"

export const isBraveBrowser = () => {
    // @ts-expect-error
    return !!(navigator && navigator.brave)
}
